import { Component } from '@angular/core'
import { SimpleDialogModel } from './dialog.model'
import { CaDialogComponent } from './ca-dialog.base'

@Component({
    selector: 'ca-simple-dialog',
    template: `
        <div class="curtain">
            <section class="component-modalDialog redesigned size-8" id="test-simpleDialog">
                <header>
                    {{title}}
                    <a class="closeModalDialog fa fa-close" (click)="confirm()"></a>
                </header>
                <div class="contentContainer scrollable nativeScrollbar inside">
                    <div class="col-full no-height">
                        <p
                            class="message"
                            [ngClass]="{'small': paragraph?.length > 500}"
                            *ngFor="let paragraph of content"
                            [innerHTML]="paragraph">
                        </p>
                    </div>
                </div>
                <footer>
                    <a class="button-primary" (click)="confirm()">{{buttonLabel}}</a>
                </footer>
            </section>
        </div>`,
})
export class SimpleDialogComponent extends CaDialogComponent<SimpleDialogModel, boolean> implements SimpleDialogModel {
    title: string
    content: string[]
    buttonLabel: string

    confirm(): void {
        this.result = true
        this.close()
    }

}